<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="6">
      <v-card class="elevation-12 mt-10 mt-lg-16 mt-md-16 mt-sm-16">
        <v-card-title class="justify-center" style="
            background-color: rgb(30, 101, 105);
            margin-bottom: 30px;
            padding-top: 20px !important;
          ">
          <img src="../../assets/img/logo_w.svg" style="width: 100%" alt="" />
        </v-card-title>

        <v-card-text class="px-9 px-md-13 px-sm-9 px-lg-16" v-if="certificateCreated">
          <v-row>
            <v-col cols="12" class="text-center">
              <p v-text="$t('personalident_certificate_created')" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-icon color="success" x-large>mdi-check</v-icon>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="px-9 px-md-13 px-sm-9 px-lg-16" v-else>
          <validation-observer ref="observer">
            <v-row>
              <v-col cols="12">
                <p v-text="$t('personalident_login_info')" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-otp-input v-model="personalident.otp" @finish="focusSubmit" :label="$t('Authenticate.EnterCode')"
                  type="number"></v-otp-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <p v-text="$t('personalident_password_info')" />
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="6">
                <validation-provider v-slot="{ errors }" :name="$t('Headers.password')" vid="password"
                  rules="required|password">
                  <v-text-field filled :label="$t('Headers.password')" v-model="personalident.password" type="password"
                    required :error-messages="errors" data-cy="registerPassword"></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" sm="6">
                <validation-provider v-slot="{ errors }" :name="$t('RegisterPage.form_label_1')"
                  rules="required|confirmed:password">
                  <v-text-field filled :label="$t('RegisterPage.form_label_1')" type="password"
                    v-model="personalident.confirm_password" required :error-messages="errors"
                    data-cy="registerConfirmPassword"></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" class="text-center">
                <v-checkbox v-model="personalident.gtcChecked" id="checkboxGTC">
                  <template v-slot:label>
                    <v-container class="ma-0 pa-0 mw-100">
                      {{ $t("RegisterPage.gdpr_2") }}
                      <a target="_blank" href="https://sign8.eu/impressum-datenschutzerklaerung/" @click.stop>
                        {{ $t("RegisterPage.gdpr") }}
                      </a>
                      {{ $t("RegisterPage.gdpr_4") }}

                      <a target="_blank" href="https://sign8.eu/agb/" @click.stop>
                        {{ $t("RegisterPage.gdpr_5") }}
                      </a>
                      {{ $t("RegisterPage.gdpr_3") }}
                    </v-container>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>

            <v-card-actions class="justify-center">
              <v-row justify="center">
                <v-col cols="12" class="text-center mb-5">
                  <custom-button id="sign" v-bind:block="false" :loading="loadingState" @click="createCertificate"
                    :text="$t('create_certificate')" :disabled="!personalident.gtcChecked" :color="mainColor"
                    type="submit" />
                </v-col>
              </v-row>
            </v-card-actions>
          </validation-observer>

          <v-row>
            <v-col cols="12" class="text-center">
              <p justify="center">
                {{ $t("provided_by_sign8") }}
                <img src="../../assets/img/logo_g.svg" style="width: 30%" alt="" />
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CustomButton from "../../components/ui/input/CustomButton";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

export default {
  components: {
    CustomButton,
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.loadingState = true;
    this.$store
      .dispatch("data/personalidentLogin", this.$route.params.secret)
      .catch(() => {
        this.$router.push('/notfound')
      }).finally(() => {
        this.loadingState = false;
      });
  },
  data() {
    return {
      personalident: {},
      mainColor: "rgb(30, 101, 104)",
      loadingState: false,
      certificateCreated: false,
    };
  },
  methods: {
    focusSubmit() {
     document.getElementById("sign").focus();
    }, 
    createCertificate() {
      this.loadingState = true;
      this.personalident.secret = this.$route.params.secret;
      this.$store
        .dispatch("data/createCertificate", this.personalident).then(() => {
          this.certificateCreated = true;
        })
        .finally(() => {
          this.loadingState = false;
        });
    },
  },
};
</script>
